var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{staticClass:"dotted-line",style:({
  'background-image': 'linear-gradient(to right, ' + (_vm.color || _vm.$colors.fontsPrimary) + ' 20%, rgba(255,255,255,0) 0%)'
  })})}
var staticRenderFns = []

export { render, staticRenderFns }